export default function UserProfilePage() {
  return <>User Profile</>;
}
